import { applyMiddleware, compose, createStore } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import rootReducer from './reducers';

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = () => {
  const middlewares = [];

  if (process.env.NODE_ENV !== "production") {
    middlewares.push(logger);
  }

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }

  // Support making action creators that return functions instead of actions
  middlewares.push(thunk);

  const store = createStore(
    rootReducer,
    {}, // preloadedState
    composeEnhancers(
      applyMiddleware(...middlewares)
    ),
  );

  return store;
}

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/index.ts